<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="
              () =>
                $router.push({
                  name: 'auditoria',
                })
            "
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Auditoria de Gestões de Aulas
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-0 pb-0">
        <v-text-field
          v-model="search"
          class="my-2"
          append-icon="mdi-magnify"
          label="Pesquisar..."
          solo
          autofocus
          dense
          clearable
          single-line
          hide-details
        />
      </v-col>
      <v-col class="pt-0">
        <v-data-table
          :headers="table.headers"
          :items="gestoesList"
          :items-per-page="15"
          :hide-default-footer="true"
          class="elevation-1"
        >
          <template v-slot:body="{ items }">
            <tbody name="scroll-x-transition" is="transition-group" duration="150">
              <tr
                color="primary"
                :class="gestao.estaDeletado ? ['deleted'] : []"
                v-for="gestao of items"
                :key="gestao.id"
              >
                <td>{{ gestao.id }}</td>
                <td>{{ gestao.turma.franquia.descricao }}</td>
                <td>{{ gestao.turma.descricao }}</td>
                <td>
                  <span v-if="gestao.disciplinas.length > 0">
                    <v-chip
                      v-for="disciplina in gestao.disciplinas"
                      :key="disciplina.id"
                      class="ma-1"
                      label
                      x-small
                      color="warning"
                    >
                      {{ disciplina.descricao ?? "- - -" }}
                    </v-chip>
                  </span>
                  <span v-if="gestao.disciplinas.length === 0">
                    {{ gestao.disciplina?.descricao ?? "- - -" }}
                  </span>
                </td>
                <td>
                  {{ gestao.professor.nome ?? "- - -" }}
                </td>
                <td>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        color="blue-grey lighten-3"
                        v-bind="attrs"
                        v-on="on"
                        @click="() => verHistorico(gestao)"
                      >
                        <v-icon small>fa fa-eye </v-icon>
                      </v-btn>
                    </template>
                    <span>Ver Histórico de Alterações</span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>

        <e-paginate
          :current_page="paginate.current_page"
          :last_page="paginate.last_page"
          :pageNumber="pageNumber"
          @changeActionResponse="listarGestoes"
          :search="search"
        ></e-paginate>
      </v-col>
    </v-row>

    <e-drawer-ver-auditoria
      v-model="exibir"
      :auditated_model="gestao ?? {}"
      :auditated_descripition="$route.name"
    >
    </e-drawer-ver-auditoria>
  </main-template>
</template>

<script>
import { dataTableFilter } from "@/plugins/searchQuery";
import GestaoDeAula from "@/Models/GestaoDeAula";

export default {
  data() {
    return {
      gestao: null,
      exibir: false,
      dataTableFilter,
      search: "",
      pageNumber: 0,
      paginate: {
        current_page: 0,
        last_page: 0,
      },
      disciplinas: [],
      disciplina: "",
      bimestres: [],
      bimestre: "",
      turmas: [],
      turma: "",
      professor: "",
      gestoesList: [],
      table: {
        headers: [
          { text: "#", value: "id" },
          { text: "Escola" },
          { text: "Turma" },
          { text: "Componente(s) Curricular" },
          { text: "Professor" },
          { text: "Ações", value: "actions", sortable: false },
        ],
      },
    };
  },
  watch: {
    gestoes(value) {
      if (value && this.gestoesList.length === 0) {
        this.$loaderService.open("Carregando gestao");
      } else {
        this.$loaderService.close();
      }
    },
    async search(val) {
      if (val?.length > 1) {
        await this.listarGestoes(0, val);
      }
      if (!val) {
        await this.listarGestoes(0);
      }
    },
  },
  async mounted() {
    this.gestoes = true;
    this.$loaderService.open("Carregando gestao");
    await this.loadData();
    this.carregandoGestoes = false;
    this.$loaderService.close();
  },

  methods: {
    async loadData() {
      await this.listarGestoes(this.pageNumber);
    },
    async listarGestoes(pageNumber, query = null) {
      this.gestoes = true;
      try {
        const response = await this.$services.gestoesDeAulasService.auditoriaPaginate(
          pageNumber,
          query
        );
        this.gestoesList = response.data.map((gestao) => new GestaoDeAula(gestao));
        this.paginate = response;
      } catch (error) {
        this.$handleError(error);
      }
      this.gestoes = false;
    },
    verHistorico(gestao) {
      this.exibir = !this.exibir;
      this.gestao = gestao;
    },
  },
};
</script>

<style></style>
